import { useEffect } from 'react';

import { Container } from '@chakra-ui/react';
import { Outlet, useLocation } from 'react-router-dom';

import Navigation from '@/components/Navigation';
import { SidebarNavbar } from '@/components/Navigation/SidebarNavigation';

import { IntroModal } from '@/elements/Modals/IntroModal';

import { RoutesEnum } from '@/enums/routes.enum';

const Layout = () => {
  const { pathname } = useLocation();

  const isGuidePage = pathname === RoutesEnum.guide;

  const isNavShown = !isGuidePage;

  useEffect(
    () => window.parent.postMessage({ type: 'scrollTop' }, '*'),
    [pathname],
  );

  return (
    <>
      <SidebarNavbar />
      {isNavShown && <Navigation />}

      <Container as='main' height='auto' maxW='630px' px='0' w='100%'>
        <Outlet />
      </Container>

      <IntroModal />
    </>
  );
};

export default Layout;
